import { ParsedUrlQuery } from 'querystring';
import { omit } from 'lodash';

export const buildQueryUrl = (currentUrl: string, query: ParsedUrlQuery) => {
    // Remove search-path so it doesn't get added as a query param
    const params = omit(query, 'search-path', 'pn');

    // Map query params to create a params string
    const queryParamString = `?${Object.entries(params)
        .map(([key, value]) => `${key}=${encodeURIComponent(value as string)}`)
        .join('&')}`;

    // Create the new url with params and push it
    const urlBase = currentUrl.split('?')[0];
    return urlBase + queryParamString;
};
